// extracted by mini-css-extract-plugin
export default {"wrapper":"JobAgent_wrapper__h2L-V"};